import { nanoid } from 'nanoid'
import React from 'react'
import modalStore from 'shared/ui/Modal/store/modalStore.ts'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import {
  type IMessageContentProps,
  MessageContent,
} from 'widgets/TemplateActions/ui/MessageContent/MessageContent.tsx'
import { EmojiAction, EnumVariantMessageField, MessageFieldStore } from 'widgets/MessageField'

export type IAddContactNoteActionProps = Omit<
  IMessageContentProps,
  'onClose' | 'questionInfoTooltip' | 'messageFieldStore' | 'title' | 'color'
> & {
  shouldHideAttachment?: boolean
}

export const addContactNote = (props: IAddContactNoteActionProps, entities: IEntitiesStore) => {
  const id = nanoid()
  const messageFieldStore = new MessageFieldStore(
    {
      placeholder: 'Write a note...',
      noCounter: true,
      variant: EnumVariantMessageField.Note,
      textLimit: {
        maxLength: 1600,
        message: 'Note can contain max 1600 characters',
        showNotification: true,
      },
      makeActions: () => [{ iconButtonComponent: <EmojiAction /> }],
    },
    entities
  )
  modalStore.addModal({
    id,
    title: 'Add contact note',
    pureContent: true,
    ModalContent: () => (
      <MessageContent
        onClose={() => modalStore.closeModal(id)}
        questionInfoTooltip={'Agent will write this note based on the conversation'}
        title={'Let AI write this note '}
        messageFieldStore={messageFieldStore}
        {...props}
      />
    ),
  })
}
